// extracted by mini-css-extract-plugin
export default {"root":"SnackbarProvider_root__o6g61"};